module.exports = __webpack_public_path__ + "img/banner-package.50ee53d5.png";